import React from 'react';
import Popup from './common/components/Popup';
import NewCard from './common/components/NewCard';

interface addCardProps {
    showPopup: boolean,
    closePopup: ()=> void,
    onAddNewCard: ()=> void
}

function AddCard(props: addCardProps) {
    const {showPopup, closePopup, onAddNewCard} = props;

    return (
        <Popup show={showPopup} onClose={closePopup} size='lg'
            backdrop='static'>
            <NewCard onClose={closePopup}
                onAddNewCard={onAddNewCard}/>
        </Popup>
    );
}

export default AddCard;
